<template>
  <div v-if="tabs" class="tab-panel-container py-2 px-3">
    <DxTabPanel height="70%">
      <DxItem v-for="(tab, index) in tabs" :key="index" :title="tab.title" class="tab-item">
        <component :is="tab.component" v-bind="tab.props"></component>
      </DxItem>
    </DxTabPanel>
  </div>
</template>

<script setup lang="ts">
import { useIntl } from '@services/i18n';
import DxTabPanel, { DxItem } from 'devextreme-vue/tab-panel';
import UnderConstruction from '@/.shared/components/UnderConstruction.vue';
import ClientesOperacionesEnergiaGrid from '@/components/clientes/ClientesOperacionesEnergiaGrid.vue'
import type { DxDataGridTypes } from 'devextreme-vue/cjs/data-grid';

const props = defineProps<{
  templateData: DxDataGridTypes.MasterDetailTemplateData;
}>();

const intl = useIntl();
const tabs = [
  { title: intl.i18n.t('operaciones_energia.tab.titulo'), component: ClientesOperacionesEnergiaGrid, props: { idCliente: props.templateData.data.IdCliente, nombreCliente: props.templateData.data.NombreCompleto }, disabled: false },
  { title: intl.i18n.t('operaciones_inmobiliaria.tab.titulo'), component: UnderConstruction, props: { idCliente: props.templateData.data.IdCliente, nombreCliente: props.templateData.data.NombreCompleto }, disabled: false },
];

</script>

<style lang="scss" scoped>


.tab-panel-container {
  background-color: var(--background-surface-default);
  border: 1px solid var(--border-default-default);
  border-radius: 5px;
}

.dx-tabpanel-container {
  padding-top: 15px;
}
</style>